export default __webpack_public_path__ + "static/media/second-layer-img-1.5ad6d734.jpg";